module.exports = __webpack_public_path__ + "static/img/logo-dogecoin.4a77d6a3.png";